import $ from 'jquery';

export const footerPosition = () => {
	const mainContainer = document.querySelector('.main-container');
	const footer = document.querySelector('.footer');

	$(window).on('resize', function(){
		mainContainer.style.paddingBottom = footer.offsetHeight + 'px';
	}).resize();
}
